export enum WiseOwlZendeskRealm {
  local = "local",
  sandbox = "sandbox",
  prod = "prod",
}

export enum WiseOwlZendeskHostname {
  prod = "twilio.zendesk.com",
  sandbox = "twilio1444173614.zendesk.com",
  local = "localhost",
}

export interface TicketConversationAttachment {
  contentType: string;
  contentUrl: string;
  filename: string;
}

export interface TicketConversationAuthor {
  id?: number;
  name: string;
  role: string;
}

export interface TicketConversationChannel {
  name: string;
}

export interface TicketConversationMessage {
  content?: string;
  contentType?: string;
}

export interface TicketCustomField {
  id: number;
  value: string;
}

// https://developer.zendesk.com/api-reference/apps/apps-support-api/ticket_sidebar/#ticketconversation
export interface TicketConversation {
  attachments: TicketConversationAttachment[];
  author: TicketConversationAuthor;
  channel: TicketConversationChannel;
  message: TicketConversationMessage;
  timestamp: string;
}

// https://developer.zendesk.com/api-reference/apps/apps-support-api/ticket_sidebar/#ticket-object
export interface ZendeskSidebarTicket {
  id: number;
  subject: string;
  conversation: TicketConversation[];
  // represents a human-readable label mapping to custom field objects, which is different
  // from how the Zendesk API would typically return this data
  customFields?: Record<string, TicketCustomField>;
}

// https://developer.zendesk.com/api-reference/ticketing/users/users/#json-format
export interface ZendeskUser {
  alias: string;
  avatarUrl: string;
  details: string;
  email: string;
  externalId: string;
  groups?: ZendeskGroup[];
  id: number;
  identities: any[];
  isSystemUser: boolean;
  locale: string;
  name: string;
  notes: string;
  organizations: ZendeskOrganization[];
  role: string;
  signature: string;
  tags: string[];
  timeZone: TimeZone;
}

// https://developer.zendesk.com/api-reference/ticketing/groups/groups/#json-format
export interface ZendeskGroup {
  id: number;
  name: string;
}

// https://developer.zendesk.com/api-reference/ticketing/organizations/organizations/#json-format
export interface ZendeskOrganization {
  domains: string;
  id: number;
  name: string;
}

export interface TimeZone {
  formattedOffset: string;
  ianaName: string;
  name: string;
  offset: number;
  translatedName: string;
}
